<template>
  <div class="container">
    <div class="row justify-content-center pb-5">
      <div class="col-12 col-md-10 col-lg-8">
        <div class="page-content" v-if="isPostLoaded">
          <div v-html="post.content.rendered"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import JQuery from 'jquery'
const Flickity = require('flickity')
export default {
  name: 'Post',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      post: [],
      isPostLoaded: false
    }
  },
  mounted () {
    this.getContent()
  },
  methods: {
    getContent () {
      const slug = encodeURIComponent(this.$route.params.slug)
      const lang = this.$route.params.lang
      axios.get(`${this.api_path}wp-json/wp/v2/pages`, {
        params: {
          slug,
          lang
        }
      })
        .then(res => {
          this.post = res.data[0]
          this.isPostLoaded = true
          document.title = `${this.post.title.rendered} - ${this.title}`
          const $ = JQuery
          setTimeout(() => {
            if ($('.has-carousel')) {
              $('.has-carousel').each(function (i) {
                var options = JSON.parse($(this).attr('data-flickity'))
                const carousel = new Flickity($('.has-carousel')[i], options)
                if (carousel) {}
              })
            }
          }, 100)
        })
    }
  },
  watch: {
    '$router.params.slug' () {
      this.getContent()
    }
  }
}
</script>
